import {
  inputBaseClasses,
  inputLabelClasses,
  TextField as MuiTextField,
  outlinedInputClasses,
  styled,
} from '@mui/material'

export const TextField = styled(MuiTextField)(({ theme }) => ({
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    border: 'none',
    background: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.grey[800]}`,
    borderRadius: theme.spacing(0.5, 0.5, 0, 0),
  },
  [`& .${outlinedInputClasses.root}`]: {
    '&.Mui-focused:not(.Mui-error)': {
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.palette.primary.main,
      },
    },
    '&.Mui-error': {
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.palette.error[500],
      },
    },
  },
  [`& .${outlinedInputClasses.input}`]: {
    height: '23px',
    padding: '22px 16px 3px',
    zIndex: 2,
    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
      // A hack to prevent the background to change when the user
      // uses the autofill feature.
      //
      // Source: https://stackoverflow.com/a/29350537
      transition: 'background-color 5000s ease-in-out 0s',
    },
  },
  [`& .${inputLabelClasses.root}.${inputLabelClasses.outlined}`]: {
    transform: 'translate(16px, 13px) scale(1)',
    '&.Mui-focused:not(.Mui-error)': {
      color: theme.palette.primary.main,
    },
    [`&.${inputLabelClasses.shrink}`]: {
      transform: 'translate(16px, 8px) scale(0.76)',
    },
  },
  [`& .${inputBaseClasses.multiline}`]: {
    paddingBottom: '4px',
    paddingLeft: '16px',
  },
  [`& .${inputBaseClasses.inputMultiline}`]: {
    paddingTop: '6px',
    zIndex: 2,
  },
}))

export const Label = styled('span')<{ required?: boolean }>(({ required, theme }) => ({
  '&::before': {
    content: required ? "'*'" : undefined,
    color: theme.palette.error[500],
  },
}))
